import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatChipListboxChange, MatChipsModule } from '@angular/material/chips';
import { PurchaseItemStatus } from '../../../interfaces/purchase-request';

export type StatusFilterOption = PurchaseItemStatus | 'ALL';

/**
 * Filtro de status dos itens como chips de filtro do Material (mat-chip-listbox, seleção única):
 * um clique para filtrar, e a contagem de cada status serve também de resumo da revisão.
 */
@Component({
  selector: 'aionz-purchase-item-status-filter',
  imports: [MatChipsModule],
  templateUrl: './purchase-item-status-filter.component.html',
  styleUrl: './purchase-item-status-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseItemStatusFilterComponent {
  public selectedStatus = input<StatusFilterOption>('ALL');
  /** Quantidade de itens por status (e o total em 'ALL'). Sem ela, os chips aparecem sem número. */
  public counts = input<Partial<Record<StatusFilterOption, number>>>({});
  public statusChange = output<StatusFilterOption>();

  private readonly baseOptions: { value: StatusFilterOption; label: string }[] = [
    { value: 'ALL', label: 'Todos' },
    { value: PurchaseItemStatus.PENDING, label: 'Pendentes' },
    { value: PurchaseItemStatus.APPROVED, label: 'Aprovados' },
    { value: PurchaseItemStatus.DECLINED, label: 'Recusados' }
  ];

  protected readonly options = computed(() =>
    this.baseOptions.map(option => ({ ...option, count: this.counts()[option.value] }))
  );

  protected onChange(event: MatChipListboxChange): void {
    // Seleção única sem "desmarcar": clicar no chip já ativo não deixa o filtro vazio.
    const value = (event.value ?? this.selectedStatus()) as StatusFilterOption;
    if (event.value == null) {
      event.source.value = value;
    }
    this.statusChange.emit(value);
  }
}
